import { useState } from "react";
import { DateTimeInput } from "../components/DateTimeInput";
import CloseIcon from "@mui/icons-material/Close";

export function AddEditMemoForm({
  isOpen,
  onClose,
  isEdit, // Boolean: true for Edit, false for Add
  description,
  dateFrom,
  dateTo,
  contentMemo,
  files,
  setDescription,
  setDateFrom,
  setDateTo,
  setContentMemo,
  setFiles,
  handleSubmitMemo
}) {
  const [errorState, setErrorState] = useState(false);

  const submit = (e) => {
    if (!description || !dateFrom || !dateTo || !contentMemo) {
      setErrorState(true);
      return;
    }
    handleSubmitMemo(e);
    setErrorState(false);
  };

  const handleClose = () => {
    onClose();
    setErrorState(false);
  };

  // for upload logic
  const handleBrowse = (e) => {
    const fileList = Array.from(e.target.files);
    setFiles(fileList);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const fileList = Array.from(e.dataTransfer.files);
    setFiles(fileList);
    e.currentTarget.style.backgroundColor = "white";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#bdbdbd7d";
  };

  const handleDragOut = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "white";
  };

  const clearFiles = () => {
    setFiles([]);
    const input = document.getElementById('fileInput');
    if (input) input.value = '';
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>{isEdit ? "Edit Memo" : "Add Memo"}</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={handleClose} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Description</div>
                <div className="info-item-input">
                  <input
                    id="description"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: !description && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field</span>
              </div>

              <div className="popUp-item info-item column">
                <div className="info-item-label">Date From</div>
                <div className="info-item-input">
                  <DateTimeInput date={dateFrom} setDate={setDateFrom} />
                </div>
                <span style={{
                  visibility: !dateFrom && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field</span>
              </div>

              <div className="popUp-item info-item column">
                <div className="info-item-label">Date To</div>
                <div className="info-item-input">
                  <DateTimeInput date={dateTo} setDate={setDateTo} />
                </div>
                <span style={{
                  visibility: !dateTo && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field</span>
              </div>

              <div className="popUp-item info-item column">
                <div className="info-item-label">Content</div>
                <div className="info-item-input">
                  <textarea 
                    id="memo-content"
                    style={{ width: "95%", minHeight: "100px", borderRadius: "3px", border: "1px solid #80808080", color: "rgb(104, 104, 104)" }}
                    value={contentMemo}
                    onChange={(e) => setContentMemo(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: !contentMemo && errorState ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>Please fill up this field</span>
              </div>

              <div className="popUp-item info-item column">
                <div className="info-item-label">Upload</div>
                <div className="info-item-input">
                  <label htmlFor="fileInput" className='browse'>Browse...</label>
                  <input
                    type="file"
                    id="fileInput"
                    onChange={(e) => handleBrowse(e)}
                    style={{ display: 'none' }}
                  />

                  {files && files.length > 0 ? (
                    <div style={{ border: "1px solid #97979745", padding: "10px" }}>
                      <span>Uploaded File:</span>
                      <ul>
                        {files.map((file, index) => (
                          <img 
                            key={index} 
                            src={file instanceof File ? URL.createObjectURL(file) : `data:image/jpeg;base64,${file}`} 
                            alt="" 
                            style={{ width: "150px", height: "auto" }} 
                          />
                        ))}
                      </ul>
                      <div className="buttons row" style={{ display: "flex", justifyContent: "end" }}>
                        <button className="cancel row" onClick={clearFiles} style={{ marginRight: "5px" }}>
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragOut}
                      style={{ border: '2px dashed #ccc', borderRadius: '5px', padding: '20px', marginTop: '10px', textAlign: 'center' }}
                    >
                      Drop files here
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button className="save row" onClick={submit}>
                {isEdit ? "UPDATE" : "SAVE"}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}